import "date-fns";
import React from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";

export default function DatePicker(props) {
  // const [date, setDate] = useState(new Date(props.data));

  // const setDate = date => {
  //   setSelectedDate(date);
  // };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid >
        <KeyboardDatePicker
          disableToolbar
          variant="inline"
          format="dd/MM/yy"
          // margin="normal"
          id={props.id}
          label={props.dateLabel}
          value={props.data}
          onChange={e => props.onChange(e)}
          KeyboardButtonProps={{
            "aria-label": "change date"
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
